import React, { useState } from 'react';
import styled from 'styled-components';
import {
    BUTTON_CONTENT_BASE,
    CONTENT_BASE,
    CONTENT_DISABLED,
    NEGATIVE_BASE,
    NEGATIVE_MUTED
} from '@amzn/ring-common-style-library/lib/colors';
import { translated } from '../../utils/TranslationUtil';

type IconProps = {
    selected: boolean;
};

const IconWrapper = styled.div<{ selected: boolean; }>`
    display: flex;
    width: 32px;
    height: 32px;
    padding: 8px;
    justify-content: center;
    align-items: center;

    border-radius: 100px;
    border: ${({ selected }) => selected ? `1px solid ${NEGATIVE_BASE}` : `1px solid ${CONTENT_DISABLED}`};
    background: ${({ selected }) => selected ? NEGATIVE_BASE : BUTTON_CONTENT_BASE};

    svg {
        width: 16px;
        height: 16px;
    }
`;

export const ThumbsDownIcon: React.FC<IconProps> = ({ selected }) => {
    const [hovered, setHovered] = useState(false);

    return (
        <IconWrapper
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
            selected={selected}
        >
            {selected ? (
                <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
                    <title>{translated('Accessibility.SvgTitle.thumbsDownIcon')}</title>
                    <g id='thumbs_down_on (ea4f)'>
                        <g id='^ Name above ^'>
                            <path
                                d='M13.4997 9.34008C14.1429 9.34008 14.6648 8.87407 14.6648 8.24771C14.6648 7.84425 14.454 7.49012 14.1429 7.28914C14.2348 7.12443 14.2981 6.93036 14.2981 6.72711C14.2981 6.3244 14.0894 6.01356 13.7783 5.81258C13.8702 5.64863 13.9254 5.46044 13.9254 5.2572C13.9254 4.85448 13.7222 4.537 13.4111 4.33602C13.503 4.17206 13.5649 3.99717 13.5649 3.79393C13.5649 3.16833 13.0575 2.66675 12.4441 2.66675H5.77745V9.33341C5.77745 9.33341 7.25893 9.41675 7.25893 10.8334V12.0001C7.25893 12.8185 7.75698 13.3153 8.37005 13.3334C8.98783 13.3517 9.67016 12.8741 9.7002 10.9037C9.7002 10.2403 9.66092 9.71484 9.61426 9.34008H13.4997Z'
                                fill={NEGATIVE_MUTED}
                            />
                            <path
                                d='M5.03671 9.33341H1.33301V3.04453C1.33301 2.83599 1.49893 2.66675 1.70338 2.66675H5.03671V9.33341Z'
                                fill={NEGATIVE_MUTED}
                            />
                        </g>
                    </g>
                </svg>
            ) : hovered ? (
                <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
                    <title>{translated('Accessibility.SvgTitle.thumbsDownIcon')}</title>
                    <g id='thumbs_down_on (ea4f)'>
                        <g id='^ Name above ^'>
                            <path
                                d='M13.4997 9.34008C14.1429 9.34008 14.6648 8.87407 14.6648 8.24771C14.6648 7.84425 14.454 7.49012 14.1429 7.28914C14.2348 7.12443 14.2981 6.93036 14.2981 6.72711C14.2981 6.3244 14.0894 6.01356 13.7783 5.81258C13.8702 5.64863 13.9254 5.46044 13.9254 5.2572C13.9254 4.85448 13.7222 4.537 13.4111 4.33602C13.503 4.17206 13.5649 3.99717 13.5649 3.79393C13.5649 3.16833 13.0575 2.66675 12.4441 2.66675H5.77745V9.33341C5.77745 9.33341 7.25893 9.41675 7.25893 10.8334V12.0001C7.25893 12.8185 7.75698 13.3153 8.37005 13.3334C8.98783 13.3517 9.67016 12.8741 9.7002 10.9037C9.7002 10.2403 9.66092 9.71484 9.61426 9.34008H13.4997Z'
                                fill={CONTENT_BASE}
                            />
                            <path
                                d='M5.03671 9.33341H1.33301V3.04453C1.33301 2.83599 1.49893 2.66675 1.70338 2.66675H5.03671V9.33341Z'
                                fill={CONTENT_BASE}
                            />
                        </g>
                    </g>
                </svg>
            ) : (
                <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
                    <title>{translated('Accessibility.SvgTitle.thumbsDownIcon')}</title>
                    <g id='thanks_no_neighborhoods (e9f2)'>
                        <path
                            id='^ Name above ^'
                            fillRule='evenodd'
                            clipRule='evenodd'
                            d='M4.94975 9.31728H1.33105L1.33708 2.66995C1.33708 2.66995 4.23163 2.66698 5.03687 2.66698L4.94975 9.31728ZM2.00641 3.33665H4.94975V8.64201H2.00641V3.33665ZM13.4544 7.39895C13.4544 7.39895 13.7152 6.99603 13.6879 6.67695C13.6515 6.25001 13.0499 6.02591 13.0499 6.02591C13.0499 6.02591 13.3155 5.57553 13.2478 5.20835C13.1852 4.86867 12.7608 4.5832 12.7608 4.5832C12.7608 4.5832 13.0473 4.17695 12.964 3.86445C12.865 3.38268 12.4334 3.33268 12.2296 3.33268H5.61969V8.7082C6.93187 8.90097 8.04715 9.57013 8.10299 10.7656V12.2293C8.10299 12.4927 8.1707 12.664 8.49051 12.664C9.08374 12.664 9.40145 12.0936 9.41708 11.1171C9.48479 10.0806 9.28818 9.19543 9.23999 8.83852H13.0994C13.4847 8.83852 14.0093 8.62971 14.0093 8.14212C14.0261 7.67806 13.4544 7.39895 13.4544 7.39895ZM14.6619 8.25508C14.5968 9.13789 13.74 9.51657 13.0317 9.51657H10.0186C10.0653 9.89484 10.1066 10.3649 10.0837 11.0467C10.0968 12.9009 9.14522 13.3306 8.49051 13.3306C7.85718 13.3306 7.40406 12.9374 7.42089 12.1721V10.9151C7.44367 9.34119 4.94975 9.31728 4.94975 9.31728L5.03687 2.66698L12.0759 2.66699C12.7322 2.66699 13.3416 2.83595 13.5942 3.62501C13.6708 3.86445 13.6488 4.25001 13.5733 4.42175C13.766 4.65105 13.8051 4.7422 13.9015 5.07553C13.9353 5.25522 13.9275 5.52866 13.8728 5.74206C14.1098 5.93997 14.214 6.09622 14.3259 6.48164C14.3768 6.6568 14.3632 7.02372 14.2712 7.18997C14.5551 7.46081 14.6947 7.8093 14.6619 8.25508Z'
                            fill={CONTENT_BASE}
                        />
                    </g>
                </svg>
            )}
        </IconWrapper>
    );
};
